module.exports = __webpack_public_path__ + "static/media/vibrationProfound.ff70f65f.png";